'use es6';

import createAction from 'flux-actions/createAction';
import { RECEIVED_CRM_OBJECT_ID, RECEIVED_CRM_OBJECTS, REQUESTED_CRM_OBJECTS, REQUESTED_CRM_OBJECTS_FAILED } from './ActionTypes';
export const requestCrmObjects = createAction(REQUESTED_CRM_OBJECTS);
export const receiveCrmObjects = createAction(RECEIVED_CRM_OBJECTS, crmObjects => ({
  crmObjects
}));
export const requestedCrmObjectsFailed = createAction(REQUESTED_CRM_OBJECTS_FAILED, error => ({
  error
}));
export const receivedCrmObjectId = createAction(RECEIVED_CRM_OBJECT_ID, objectId => ({
  objectId
}));